export enum WalletModelStep {
    empty = 'empty',
    send_money = 'send_money',
    remove_money = 'remove_money',
    user_infos = 'user_infos',
    send_success = 'send_success' ,
    remove_success = 'remove_success',
    confirm_infos = 'confirm_infos'
  }
  